import { render } from "./OperacaoPage.vue?vue&type=template&id=98bbcab0"
import script from "./OperacaoPage.vue?vue&type=script&lang=js"
export * from "./OperacaoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__